import styled from "styled-components";

export const PanelFooter = styled.div`
  color: #a0a0a0;
  font-size: 0.8125rem;
  margin-bottom: 24px;
  padding: 0 0 10px;
`;

const SidebarCol = styled.div`
  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    .card {
      margin-bottom: 2rem;
    }
  }

  .card {
    margin-bottom: 2.5rem;
  }
`;

const SidebarContent = styled.div`
  &.full-height {
    display: flex;
    flex-direction: column;
  }
`;

/**
 * A standard layout component that splits the view into a main content area (left/top)
 * and a sidebar area (right/bottom).
 * 
 * Used across the dashboard for pages that require a primary workspace and a secondary
 * informational or action panel.
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The main content rendered in the larger column.
 * @param {string} [props.message] - Optional HTML string rendered as a helpful message at the top of the sidebar.
 * @param {React.ReactNode} [props.panel] - Optional React elements rendered in the sidebar below the message.
 * @param {string} [props.contentClassName=''] - Additional CSS classes for the main content column.
 * @returns {React.ReactElement} The two-column layout structure.
 */
const SidebarLayout = ({ children, message, panel, contentClassName = '' }) => {
  return (
    <>
      <SidebarContent className={`col-12 col-xl-9 ${contentClassName}`}>
        {children}
      </SidebarContent>
      <SidebarCol className="col-12 col-xl-3">
        <>
          {
            message
              ? (
                <PanelFooter dangerouslySetInnerHTML={{__html: message}} />
              )
              : null
          }
          {panel}
        </>
      </SidebarCol>
    </>
  );
};

export default SidebarLayout;
